import React from 'react'
import BaseCard from './base_card'
import { convertMatchingRate } from '../../enums/MatchingRate'
import { PeriodType, PeriodTypeLabel } from '../../enums/PeriodType'

interface StatCardProps {
  displayCount: number
  displayEnterpriseCount: number
  matchingRate: number
  periodLabel?: string
}

const StatCard: React.FC<StatCardProps> = ({
  displayCount,
  displayEnterpriseCount,
  matchingRate,
  periodLabel = PeriodTypeLabel[PeriodType.SEVEN_DAYS],
}) => {
  const stats = [
    {
      label: '訪問企業数',
      value: displayEnterpriseCount,
      description: periodLabel,
    },
    {
      label: '総訪問回数',
      value: displayCount,
      description: periodLabel,
    },
    {
      label: '平均マッチング率',
      value: convertMatchingRate(matchingRate),
      description: '訪問企業との平均',
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {stats.map((stat, index) => (
        <BaseCard key={index}>
          <div className="text-left">
            <div className="text-sm font-bold text-main-darkgray mb-2">
              {stat.label}
            </div>
            <div className="text-3xl font-bold text-main-black mb-1">
              {stat.value}
            </div>
            <div className="text-xs text-main-darkgray">{stat.description}</div>
          </div>
        </BaseCard>
      ))}
    </div>
  )
}

export default StatCard
